import { render, staticRenderFns } from "./DropdownButtonMobile.vue?vue&type=template&id=52ababeb&"
import script from "./DropdownButtonMobile.vue?vue&type=script&lang=js&"
export * from "./DropdownButtonMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports